<template>
  <div class="header-container d-flex align-items-center justify-content-center">
    <img :src="imageUrl" :alt="imageAlt" class="background-image" loading="lazy" />
    <div class="title text-center align-items-center justify-content-center">
      <prismic-rich-text v-if="title" :field="title" :style="titleStyle"></prismic-rich-text>
      <prismic-rich-text
        v-if="subtitle"
        class="mt-3 header-subtitle"
        :style="titleStyle"
        :field="subtitle"
      ></prismic-rich-text>
      <div v-if="buttonText" class="d-flex align-items-center justify-content-center w-100 mt-5">
        <ButtonActions
          v-if="buttonText"
          :blank="buttonBlank"
          :path="buttonPath"
          :anchor-id-target="anchorIdTarget"
          :open-modal="openModal"
        >
          <template #action-scroll="{ item }">
            <Button
              :to="item.path"
              :blank="item.blank"
              :extra-data="anchorIdTarget ? { event: '' } : {}"
            >
              {{ buttonText }}
            </Button>
          </template>
        </ButtonActions>
      </div>
    </div>
  </div>
</template>

<script>
import Button from 'UI/Button';
import ButtonActions from '@/components/Prismic/Landings/Utils/ButtonActions.vue';

export default {
  components: {
    Button,
    ButtonActions
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      buttonBlank: false,
      buttonPath: '',
      buttonText: '',
      imageAlt: '',
      imageUrl: '',
      openModal: false,
      subtitle: '',
      title: '',
      titleColor: '',
      anchorIdTarget: ''
    };
  },
  computed: {
    titleStyle() {
      return { color: this.titleColor };
    }
  },
  created() {
    this.buttonBlank = this.slice.primary.button_blank;
    this.buttonPath = this.slice.primary.button_path[0]?.text;
    this.buttonText = this.slice.primary.button_text[0]?.text;
    this.imageAlt = this.slice.primary.image.alt;
    this.imageUrl = this.slice.primary.image.url;
    this.openModal = this.slice.primary.open_modal;
    this.subtitle = this.slice.primary.subtitle;
    this.title = this.slice.primary.title1[0]?.text ? this.slice.primary.title1 : '';
    this.titleColor = this.slice.primary.title_color ? this.slice.primary.title_color : 'black';
    this.anchorIdTarget = this.slice.primary.anchor_id_target;
  }
};
</script>

<style scoped>
.header-container {
  position: relative;
  overflow: hidden;
  height: 350px;
  border-radius: 5px;
}
.background-image {
  position: absolute;
  opacity: 0.9;
  top: 0;
  width: auto;
  height: 100%;
  z-index: 0;
}
.title {
  z-index: 1;
}
</style>

<style>
.header-subtitle h2 {
  font-size: 1.5em;
}
</style>
